import storesReducer from './stores.reducer';
export default storesReducer;

export * from './stores.selectors';
